import React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';

interface ICardProps {
  isDefault: boolean;
  defaultLabel: string;
  isInactive?: boolean;
  children: React.ReactNode;
}

export const Card = ({
  isDefault,
  isInactive = false,
  defaultLabel,
  children,
}: ICardProps) => {
  return (
    <>
      <div
        data-testid="card"
        className={`sui-w-full sui-h-full sui-p-4 sui-bg-primary sui-rounded-base sui-border-solid
        ${
          isDefault
            ? 'sui-border-2 sui-border-accent'
            : 'sui-border-1 sui-border-inactive'
        }`}
      >
        {isDefault && (
          <Typography weight="bold" color={isInactive ? 'inactive' : 'subtle'}>
            {defaultLabel}
          </Typography>
        )}
        {children}
      </div>
    </>
  );
};

Card.displayName = 'Card';
